import { Currency } from "@evennt-tech/api-v2-core";
import { apiV2 } from "api/firebase";

export const STRIPE_CONNECT_BAR_HEIGHT = 56;

export const getStripeRedirectUrl = async (
  currency: Currency,
  domain: string
): Promise<string> => {
  const { redirectUrl } = await apiV2.stripeOnBoard.getRedirectUrl({
    currency,
    domain,
  });

  return redirectUrl;
};
